import Cookies from 'js-cookie';

export function useCookie<T>(key: string) {
  function get(): T | null {
    const cookieValue = Cookies.get(key);
    if (!cookieValue) return null;

    try {
      return JSON.parse(cookieValue) as T;
    } catch {
      return cookieValue as unknown as T;
    }
  }

  function set(value: T, options?: Cookies.CookieAttributes) {
    Cookies.set(key, JSON.stringify(value), options);
  }

  function remove() {
    Cookies.remove(key);
  }

  return {
    get,
    set,
    remove,
  };
}
